import { useFlowType } from "@lending/hooks/useFlowType";
import { useLendingApplicationID } from "@lending/hooks/useLendingApplicationID";
import { useProductType } from "@lending/hooks/useProductType";
import { useApi } from "@lending/lib/api";
import { getMembershipShareEndpoint } from "@lending/pages/Common/MembershipShare/hooks/getMembershipShareEndpoint";

const DEFAULT_OPTIONS = {
  enabled: true,
  retry: false,
  refetchOnWindowFocus: false,
} as const;

interface Options {
  enabled?: boolean;
}

function useGetMembershipShareAccessQuery(optionsProp: Options = DEFAULT_OPTIONS) {
  const $api = useApi();
  const applicationUuid = useLendingApplicationID();
  const productType = useProductType();
  const flowType = useFlowType();
  const endpoint = getMembershipShareEndpoint(productType, "membership_share_access");
  const options = { ...DEFAULT_OPTIONS, ...optionsProp };

  return $api.useQuery(
    "get",
    endpoint,
    {
      params: {
        path: {
          uuid: applicationUuid,
        },
      },
    },
    {
      enabled: Boolean(applicationUuid && flowType) && options.enabled,
      retry: options.retry,
      refetchOnWindowFocus: options.refetchOnWindowFocus,
    }
  );
}

export { useGetMembershipShareAccessQuery };
